import React from 'react';
import {Map} from 'immutable';
import {lightGreyBackground} from './Bootflow';
import {ADD_TO_CART_STATES, STATE} from '@packages/systems/commerce/constants';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {WebflowEnvironments} from '@packages/systems/core-constants';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {Atom} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {useRuntimeEnvironment} from '@packages/systems/render';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const styleDisplayNone = Map({style: Map({display: 'none'})});
const resetDisplay = Map({style: Map({display: ''})});

const CommerceAddToCartOutOfStock = Atom.createRender((blockProps) => {
  const {context, attributes, classes, data, generateAttributes, renderChild} =
    blockProps;
  const runtimeEnvironment = useRuntimeEnvironment();
  const isDesigner = runtimeEnvironment === WebflowEnvironments.DESIGNER;

  let styledAttributes = attributes.merge(styleDisplayNone);

  if (isDesigner && context.get(STATE) === ADD_TO_CART_STATES.OUT_OF_STOCK) {
    styledAttributes = attributes.merge(resetDisplay);
  }

  return (
    <div
      {...generateAttributes(styledAttributes, classes)}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
    >
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </div>
  );
});

const config = createIntegratedAtom({
  showEmpty: true,
  displayName: 'Out of Stock State',
  uiStateOnSelected: ADD_TO_CART_STATES.OUT_OF_STOCK,
  constraints: {
    pinToParent: true,
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginTop: px(10),
          paddingTop: px(10),
          paddingBottom: px(10),
          paddingLeft: px(10),
          paddingRight: px(10),
          backgroundColor: lightGreyBackground,
        },
      },
    },
  },
  render: CommerceAddToCartOutOfStock,
  fields: {children: TListOfElement},
});

export default config;
